const getProjectById = ({ id }) => ({
  method: "GET",
  url: `/projects/${id}`,
});

const getProjectsList = (data) => ({
  method: "GET",
  url: `/projects`,
  data,
});

export const projectsApi = {
  getProjectById,
  getProjectsList,
};
